import React from 'react'
import styled from 'styled-components'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Filler,
  Tooltip,
  Legend,
  ChartData,
  ChartOptions,
} from 'chart.js'
import { Line, Bar, Pie } from 'react-chartjs-2'
import { Text } from '@thirstycamel/ui'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Filler,
  Tooltip,
  Legend,
)

const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 20px 24px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  width: 100%;
  min-width: 0;
`

const ChartFrame = styled.div`
  height: 220px;
  width: 100%;
  min-width: 0;
  overflow: hidden;

  canvas {
    max-width: 100% !important;
  }
`

type Props = {
  title: string
  chartType: 'line' | 'area' | 'bar' | 'pie'
  data: ChartData<'line'> | ChartData<'bar'> | ChartData<'pie'>
  options: ChartOptions<'line' | 'bar' | 'pie'>
}

const ReportingChartCard = ({ title, chartType, data, options }: Props) => {
  return (
    <Card>
      <Text fontSize="lg" fontWeight="extrabold" color="#cd1f3d" mb={3}>
        {title}
      </Text>
      <ChartFrame>
        {chartType === 'pie' ? (
          <Pie data={data as ChartData<'pie'>} options={options as ChartOptions<'pie'>} />
        ) : chartType === 'bar' ? (
          <Bar data={data as ChartData<'bar'>} options={options as ChartOptions<'bar'>} />
        ) : (
          <Line data={data as ChartData<'line'>} options={options as ChartOptions<'line'>} />
        )}
      </ChartFrame>
    </Card>
  )
}

export default ReportingChartCard
